import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail"; 
import Gallery from "./pages/Gallery";
import About from "./pages/About";
import Contact from "./pages/Contact";
import InquiryCartPage from "./pages/InquiryCartPage"; // New Page Import
import { Toaster } from "./components/ui/toaster";
import { InquiryProvider } from "./context/InquiryContext"; // Import Provider

function App() {
  return (
    <div className="App">
      <InquiryProvider>
        <BrowserRouter>
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/products" element={<Products />} />
            <Route path="/product/:id" element={<ProductDetail />} /> 
            <Route path="/inquiry-cart" element={<InquiryCartPage />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
          <Footer />
          <Toaster />
        </BrowserRouter>
      </InquiryProvider>
    </div>
  );
}

export default App;
